import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Collapse } from "@mui/material";

const HighIncome = ({
  phoneNumber = "800-816-1003",
  heroSectionTitle,
  heroSectionDescription,
  defaultDesc,
}) => {
  const [showText, setShowText] = React.useState(false);
  const points = [
    "Exclusive Program for Texas Residents",
    "Dedicated Specialists for $50K - $300K+ In Debt",
    "Free No-Obligation Consultation",
    "Receive up to 40% Lower Fees*",
  ];

  return (
    <React.Fragment>
      <div className="md:hidden pb-6">
        <div className="bg-green-800 py-5">
          <div className="container px-4 sm:px-8">
            <p className="text-white font-semibold text-2xl">
              Debt Relief Program for{" "}
              <span className="text-orange-400 border-orange-400 border-b-[3px]">
                High-Income
              </span>{" "}
              Earners
            </p>
          </div>
        </div>
        <div className="bg-[#f4f4f4] py-5">
          <div className="container px-4 sm:px-8">
            <div className="text-green-800 flex flex-col gap-2 font-semibold text-xl">
              {points.map((point, index) => (
                <p className="flex items-center" key={index}>
                  <img
                    src="/svgs/check-yellow.svg"
                    className="me-2 mt-0.5"
                    width={18}
                    height={14}
                    alt="Check"
                  />{" "}
                  {point}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-green-800 py-8 max-md:hidden">
        <div className="container">
          <h2 className="text-white font-medium text-center xl:leading-[45px] text-2xl sm:text-4xl">
            Experienced Texas Debt Specialists are available for{" "}
            <span className="text-orange-400">higher-income</span> earners with
            50K to 300K+ in credit cards and personal loans.
          </h2>
          <div className="mt-6 flex flex-col items-center justify-center sm:hidden">
            <p className="text-white text-md mb-2">
              Are you a <span className="text-orange-400">higher-income</span>{" "}
              earner?
            </p>
            <a
              href={`tel:${phoneNumber.replaceAll("-", "")}`}
              className="bg-green-800 font-bold rounded-xl uppercase text-white text-4xl px-4 py-1"
            >
              call now
            </a>
          </div>
        </div>
      </div>
      {heroSectionTitle && (
        <div className="bg-white py-12">
          <div className="container px-4 sm:px-8">
            <div className="grid md:grid-cols-[55%_45%] gap-2 place-items-center">
              <div>
                <h1 className="text-4xl text-sky-700 lg:text-5xl mb-4 font-bold">
                  {heroSectionTitle}
                </h1>
                <div className="max-sm:hidden">
                  <p className="font-semibold text-green-800 text-justify">
                    {heroSectionDescription
                      ? heroSectionDescription
                      : defaultDesc}
                  </p>
                </div>
                <div className="sm:hidden">
                  <Collapse in={showText} collapsedSize={70}>
                    <p className="font-semibold text-justify text-green-800">
                      {heroSectionDescription
                        ? heroSectionDescription
                        : defaultDesc}
                    </p>
                  </Collapse>
                  {!showText && (
                    <button
                      className="font-bold underline"
                      onClick={() => setShowText(true)}
                    >
                      See more
                    </button>
                  )}
                </div>
              </div>
              <div>
                <StaticImage
                  src="https://adc-dr-assets.s3.amazonaws.com/debtredemption/images/sapiens.webp"
                  className="w-full h-full"
                  alt="Sapiens"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="bg-gray-100 p-6 max-md:hidden">
        <div className="flex justify-center max-tab:flex-col items-center gap-12">
          <div>
            <p className="text-green-800 text-2xl">
              Are you a <span className="text-orange-400">higher-income</span>{" "}
              earner?
            </p>
            <a href={`tel:${phoneNumber.replaceAll("-", "")}`}>
              <h5 className="text-green-800 uppercase font-bold text-5xl text-center">
                call now
              </h5>
            </a>
          </div>
          <a
            href={`tel:${phoneNumber.replaceAll("-", "")}`}
            className="bg-green-800 font-bold rounded-xl text-white text-5xl px-2 py-1"
          >
            {phoneNumber}
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HighIncome;
